/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeMonthlyPaymentPostRequestSchema } from './changeMonthlyPaymentPostRequestSchema.ts';
import { changeMonthlyPaymentPostResponseSchema } from './changeMonthlyPaymentPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postChangeMonthlyPayment200Schema = z.lazy(() => changeMonthlyPaymentPostResponseSchema);

/**
 * @description 505 response
 */
export const postChangeMonthlyPayment505Schema = z.any();

export const postChangeMonthlyPaymentMutationRequestSchema = z.lazy(() => changeMonthlyPaymentPostRequestSchema);

export const postChangeMonthlyPaymentMutationResponseSchema = z.lazy(() => postChangeMonthlyPayment200Schema);
